"use client";

import { useIsMobile } from "@/hooks/breakpoints";
import type { CustomLocation, MapAreaId } from "@/utils/location";
import LocationSelectorDesktop from "./LocationSelectorDesktop";
import LocationSelectorMobile from "./LocationSelectorMobile";

type LocationSelectorProps = {
  currentArea: MapAreaId;
  className?: string;
  currentCustomLocation?: CustomLocation | null;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export default function LocationSelector({
  currentArea,
  className,
  currentCustomLocation,
  isOpen,
  onOpenChange,
}: LocationSelectorProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <LocationSelectorMobile
        className={className}
        currentArea={currentArea}
        currentCustomLocation={currentCustomLocation}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      />
    );
  }

  return (
    <LocationSelectorDesktop
      className={className}
      currentArea={currentArea}
      currentCustomLocation={currentCustomLocation}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    />
  );
}
